// extracted by mini-css-extract-plugin
export default {"verificationFailedRoot":"verify_verificationFailedRoot__5lHok","verificationFailedContainer":"verify_verificationFailedContainer__bIgDH"};